import { render, staticRenderFns } from "./AgentReceiptList.vue?vue&type=template&id=ef2a15f8&scoped=true"
import script from "./AgentReceiptList.vue?vue&type=script&lang=js"
export * from "./AgentReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a15f8",
  null
  
)

export default component.exports